import { ReactComponent as Clement } from '../assets/team/clement.svg';
import { ReactComponent as Lydie } from '../assets/team/lydie.svg';
import { ReactComponent as Romuald } from '../assets/team/romuald.svg';
import { ReactComponent as Vincent } from '../assets/team/vincent.svg';
import { ReactComponent as Marion } from '../assets/team/f1.svg';
import { ReactComponent as Uriel } from '../assets/team/m2.svg';
import { ReactComponent as Maxime } from '../assets/team/m3.svg';
import { defaultLocale, getLocaleFromPath } from '../i18n/locales';
import memberContentEn from './members.en';
import memberContentFr from './members.fr';

const memberContent = {
    en: memberContentEn,
    fr: memberContentFr,
};

const DataSource = [
    {
        id: "clement",
        name: "Clément",
        image: (<Clement />),
        team: "internal",
        techs: ["Swift", "Kotlin", "Flutter"],
    },
    {
        id: "lydie",
        name: "Lydie",
        image: (<Lydie />),
        team: "internal",
        techs: ["C", "Python", "Atlassian"],
    },
    {
        id: "romuald",
        name: "Romuald",
        image: (<Romuald />),
        team: "internal",
        techs: ["Swift", "Flutter"],
    },
    {
        id: "vincent",
        name: "Vincent",
        image: (<Vincent />),
        team: "internal",
        techs: ["Unity"],
    },
    {
        id: "marion",
        name: "Marion",
        image: (<Marion />),
        team: "external",
        techs: ["Photoshop", "Illustrator"],
        website: "https://www.marion-wang.fr",
    },
    {
        id: "uriel",
        name: "Uriel",
        image: (<Uriel />),
        team: "external",
        techs: ["Blender", "Spine"],
        website: "https://www.artstation.com/fogryu",
    },
    {
        id: "maxime",
        name: "Maxime",
        image: (<Maxime />),
        team: "external",
        techs: ["FL Studio"],
        website: "https://soundcloud.com/maximeferrieu",
    }
];

function currentLocale() {
    return typeof window === 'undefined' ? defaultLocale : getLocaleFromPath(window.location.pathname);
}

function localizedMembers(locale) {
    return DataSource.map(member => ({
        ...member,
        ...memberContent.fr[member.id],
        ...memberContent[locale]?.[member.id],
    }));
}

function Query({filter, sort, limit, offset, locale} = {}) {
    let members = localizedMembers(locale || currentLocale());

    if (filter) {
        members = members.filter(member => member.team == filter);
    }

    if (sort) {
        members = members.sort((a, b) => a.name.localeCompare(b.name));
    }

    if (limit) {
        members = members.slice(offset || 0, limit);
    }

    return members;
}

export default Query;
